module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-research-development-hero-lowres.6703bc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-research-development-hero-lowres.jpg
// module id = XbiH
// module chunks = 0